import { useTranslationsContext } from 'store/translations';
import Arrow from 'assets/img/smooth-arrow.svg';
import './UnopenedPresentsOverlay.styl';
import { ReactNode, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useResize } from 'src/hooks';

interface UnopenedPresentsOverlayProps {
    navigation: ReactNode;
}

export const UnopenedPresentsOverlay = observer(({ navigation }: UnopenedPresentsOverlayProps) => {
    const { translate } = useTranslationsContext();
    const { isMob } = useStoreContext();
    const { width } = useResize();
    const [left, setLeft] = useState(isMob ? 329 : 0);

    useLayoutEffect(() => {
        if (isMob) {
            const elem = document.querySelector(
                '.unopened-presents-overlay-navigation #presents .navigation-item-icon'
            );
            if (elem) {
                setLeft(elem.getBoundingClientRect().left - 193);
            }
        }
    }, [width]);

    return (
        <div className="unopened-presents-overlay">
            <div className="unopened-presents-overlay-content" style={{ left: left ? `${left}px` : undefined }}>
                <div className="unopened-presents-overlay-content-title">{translate('unopened.presents.overlay')}</div>
                <img className="unopened-presents-overlay-content-arrow" src={Arrow}></img>
            </div>
            <div className="unopened-presents-overlay-navigation">{navigation}</div>
        </div>
    );
});
